import PolicyHelper from '@/utilities/system/helpers/PolicyHelper';
import PermissionService from "@/utilities/system/services/PermissionService";
import router from "@/router";
/*
    check if user needs to reauthenticate and reroute path to login-page
*/
export default function checkPermissionForRoute ({next, to}:any){
    const policy = PolicyHelper.getPolicyFromRoute(to.path);
    if (!PermissionService.userHasPermission(policy)){
        router.push("/error").then();
    }

    return next();
}
